var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25672 0.934212C7.53172 0.281043 8.46832 0.281044 8.74332 0.934214L10.3663 4.78933C10.4823 5.06469 10.7445 5.25284 11.0454 5.27667L15.2582 5.61033C15.972 5.66686 16.2614 6.54686 15.7175 7.00707L12.5079 9.72329C12.2786 9.91734 12.1784 10.2218 12.2485 10.5118L13.2291 14.5732C13.3952 15.2613 12.6375 15.8052 12.0264 15.4365L8.41965 13.26C8.16202 13.1045 7.83802 13.1045 7.5804 13.26L3.9736 15.4365C3.3625 15.8052 2.60477 15.2613 2.77091 14.5732L3.75155 10.5118C3.82159 10.2218 3.72147 9.91734 3.49221 9.72329L0.28245 7.00707C-0.261375 6.54686 0.0280544 5.66686 0.741835 5.61033L4.9547 5.27667C5.25561 5.25284 5.51774 5.06469 5.63367 4.78933L7.25672 0.934212Z",
    fill: "#EB511C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiting);
export default __webpack_public_path__ + "static/media/raiting.138b1b3c6df310fd2679db233f5ce92e.svg";
export { ForwardRef as ReactComponent };